import PropTypes from 'prop-types';
import React from 'react';
import { TextButton } from '@bibliocommons/deprecated-base-buttons';
import { Pencil as PencilIcon, Remove as RemoveIcon } from '@bibliocommons/deprecated-base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import './DisplayActions.scss';

export default function DisplayActions({
  handleEdit,
  handleRemove,
  isRemoving,
  editScreenReaderMessage,
  removeScreenReaderMessage
}) {
  return (
    <div className="cp-ugc-display-actions">
      {handleEdit && (
        <TextButton className="ugc-display-edit-button" handleClick={handleEdit}>
          <ScreenReaderMessage>{editScreenReaderMessage}</ScreenReaderMessage>
          <PencilIcon />
        </TextButton>
      )}
      {handleRemove && (
        <TextButton className="ugc-display-delete-button" handleClick={handleRemove} isLoading={isRemoving}>
          <ScreenReaderMessage>{removeScreenReaderMessage}</ScreenReaderMessage>
          <RemoveIcon />
        </TextButton>
      )}
    </div>
  );
}

DisplayActions.propTypes = {
  handleEdit: PropTypes.func,
  handleRemove: PropTypes.func,
  isRemoving: PropTypes.bool,
  editScreenReaderMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  removeScreenReaderMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};
